import type { FC } from 'react'

import type { GeomateSearchFiltersProps as Props } from '../types'

export const DBSearchFiltersGeomate: FC<Props> = () => {
  return null
}
